// extracted by mini-css-extract-plugin
export default {"title":"Title_title__AxHGL","subtitle_big":"Title_subtitle_big__iXyek","subtitle_small":"Title_subtitle_small__xve1c"};